


























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CampaignContact } from '@/data/models/campaign.model';
import { cloneDeep } from 'lodash';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class CallCenterRecall extends Vue {
	@Prop() model!: CampaignContact;

	newModel!: CampaignContact;

	minTime!: Date;

	constructor() {
		super();
		this.newModel = new CampaignContact();
		this.minTime = new Date();
		this.minTime.setMinutes(this.minTime.getMinutes() + 1);
	}

	beforeMount() {
		this.newModel = cloneDeep(this.model);
	}

	submit() {
		this.$emit('submit', this.newModel);
	}

}
